@if (reservation$ | async; as reservation) {
  <!-- Als h1: es ist die Ueberschrift des Schritts, nicht nur groesserer Text.
       Im Gutschein-Flow gibt es sonst keine, der Header traegt nur ein div. -->
  <h1>{{ "PAGES.VOUCHER.RESERVED.TITLE" | translate }}</h1>
  <div class="spacer spacer-1"></div>
  <p class="paragraph">{{ "PAGES.VOUCHER.RESERVED.HINT" | translate }}</p>

  <div class="spacer spacer-2"></div>

  <!-- Ohne Gutscheinkarte: hier wird kontrolliert, nicht praesentiert — die
       Grafik stand mit 200px genau ueber den Zahlen, um die es geht. -->
  <dl class="voucher-summary">
    <div class="voucher-summary__row voucher-summary__row--divider">
      <dt>{{ "PAGES.VOUCHER.RESERVED.VOUCHER" | translate }}</dt>
      <dd>
        {{
          reservation.voucher.title ||
            ("PAGES.VOUCHER.TITLE_FALLBACK" | translate)
        }}
        <span class="voucher-summary__sub">{{ reservation.voucher.code }}</span>
      </dd>
    </div>

    <!-- Die Apotheke ist der Kontext, darunter faengt die Rechnung an. -->
    <div class="voucher-summary__row voucher-summary__row--divider">
      <dt>{{ "PAGES.VOUCHER.PHARMACY.LABEL" | translate }}</dt>
      <dd>
        @if (pharmacy$ | async; as pharmacy) {
          {{ pharmacy.name }}
          <span class="voucher-summary__sub">{{
            pharmacy.pharmacy_number
          }}</span>
        }
      </dd>
    </div>

    <div class="voucher-summary__row">
      <dt>{{ "PAGES.VOUCHER.RESERVED.BEFORE" | translate }}</dt>
      <dd>€ {{ balanceBefore(reservation) | number: "1.2-2" }}</dd>
    </div>

    <!-- Der Wert, um den es geht — deshalb hervorgehoben. -->
    <div class="voucher-summary__row voucher-summary__row--highlight">
      <dt>{{ "PAGES.VOUCHER.RESERVED.AMOUNT" | translate }}</dt>
      <dd>€ {{ reservation.reserved_value | number: "1.2-2" }}</dd>
    </div>

    <div class="voucher-summary__row">
      <dt>{{ "PAGES.VOUCHER.RESERVED.REMAINING" | translate }}</dt>
      <dd>€ {{ reservation.voucher.value_current | number: "1.2-2" }}</dd>
    </div>
  </dl>

  <div class="spacer spacer-3"></div>

  @if (
    (confirmStatus$ | async) === STATES.LOADING ||
    (cancelStatus$ | async) === STATES.LOADING
  ) {
    <app-loading></app-loading>
  } @else {
    <app-button
      [label]="'PAGES.VOUCHER.RESERVED.CONFIRM' | translate"
      [buttonType]="ButtonType.Blue"
      [fullWidth]="true"
      (action)="confirmReservation()"
    ></app-button>
    <div class="spacer spacer-2"></div>
    <app-button
      [label]="'PAGES.VOUCHER.RESERVED.CANCEL' | translate"
      [buttonType]="ButtonType.Secondary"
      [fullWidth]="true"
      (action)="cancelReservation()"
    ></app-button>
  }

  @if ((confirmStatus$ | async) === STATES.ERROR) {
    <div class="spacer spacer-2"></div>
    <app-message-box
      [message]="confirmError"
      [messageType]="MessageType.Error"
    ></app-message-box>
  }

  @if ((cancelStatus$ | async) === STATES.ERROR) {
    <div class="spacer spacer-2"></div>
    <app-message-box
      [message]="cancelError"
      [messageType]="MessageType.Error"
    ></app-message-box>
  }

  <div class="spacer spacer-4"></div>
}
